import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_BUSINESS_ALIGNMENT } from "constants/businessAlignment";

export const BEST_FIT_PROFILE_KEYS = {
  E_BUY: "eBuy",
  SAM_GOV: "samGov",
  UK_TENDER: "ukTender",
};

const profileEntry = (initialProfile = null) => ({
  profile: initialProfile,
  isSetup: false,
  saveProgress: null,
});

export const INITIAL_STATE = {
  [BEST_FIT_PROFILE_KEYS.E_BUY]: profileEntry(),
  [BEST_FIT_PROFILE_KEYS.SAM_GOV]: profileEntry(DEFAULT_BUSINESS_ALIGNMENT),
  [BEST_FIT_PROFILE_KEYS.UK_TENDER]: profileEntry(),
};

export const bestFitProfilesSlice = createSlice({
  name: "bestFitProfiles",
  initialState: INITIAL_STATE,
  reducers: {
    setBestFitProfile(state, { payload: { key, profile } }) {
      state[key].profile = profile;
    },
    setBestFitProfileIsSetup(state, { payload: { key, isSetup } }) {
      state[key].isSetup = isSetup;
    },
    setBestFitProfileSaveProgress(state, { payload: { key, progress } }) {
      state[key].saveProgress = progress;
    },
    clearBestFitProfileSaveProgress(state, { payload: { key } }) {
      state[key].saveProgress = null;
    },
  },
});

export const {
  setBestFitProfile,
  setBestFitProfileIsSetup,
  setBestFitProfileSaveProgress,
  clearBestFitProfileSaveProgress,
} = bestFitProfilesSlice.actions;

export default bestFitProfilesSlice.reducer;
